import { IonAvatar, IonRouterLink } from "@ionic/react";
import "./index.css";
import { InterestList } from "../../../Interfaces/Interest";
import InterestTile from "../ItemTile";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { useContext } from "react";
import { UserContext } from "../../../lib/context";

type Props = {
  refresh;
  focus;
};

const InterestSlider: React.FC<Props> = ({ refresh, focus }) => {
  // const { koroPublicAvatar } = useContext(UserContext);

  if (focus == "all") {
    return (
      <div className="on-padding-start ion-margin">
        <Swiper
          spaceBetween={10}
          slidesPerView={2.5}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
        >
          {InterestList.map((interest, index) => {
            return (
              <SwiperSlide key={interest.title}>
                <InterestTile item={interest} refresh={refresh} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  }

  return <></>;
};

export default InterestSlider;
